function handles() {
  return true;
}

export default handles;



// WEBPACK FOOTER //
// ./src/components/OtherPost/handles.js